import { StreamCard } from "./StreamCard";
import { STREAMS, type StreamId } from "../constants";

interface HomeViewProps {
  onNavigate: (id: StreamId) => void;
}

export function HomeView({ onNavigate }: HomeViewProps) {
  return (
    <div className="animate-[fade-in_0.3s_ease-out] min-h-screen">
      <div className="max-w-[1600px] mx-auto px-6 md:px-8 lg:px-12">
        <header className="py-8 md:py-12 lg:py-16 text-center md:text-left">
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[0.9]">
            SWANSONG
            <span className="text-[var(--text-muted)] md:block"> RADIO</span>
          </h1>
          <p className="font-mono text-xs tracking-[0.3em] text-[var(--text-muted)] mt-3 uppercase">
            Streaming from the void
          </p>
        </header>

        <main className="pb-28">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {(Object.keys(STREAMS) as StreamId[]).map((id, i) => (
              <div
                key={id}
                style={{ animationDelay: `${i * 0.05}s` }}
                className="animate-[slide-up_0.4s_ease-out_forwards] opacity-0"
              >
                <StreamCard id={id} onNavigate={onNavigate} />
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
